import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  CheckCircleFilled,
  InfoCircleOutlined,
  LoadingOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Button, Skeleton, Tooltip } from "antd";
import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { cardData } from "../scripts/products";
import { useNavigate } from "react-router-dom";
import DoughnutChart from "./DoughnutChart";
import { summaryService } from "../api";
import { useSelector } from "react-redux";
import { getProduct, getReferences, getThread } from "../redux/selectors";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import { calcChange } from "../scripts/utils";
import { PieChart } from "./Charts/PieChart";

const ShareofVoices = () => {
  const [current, setCurrent] = useState(1);
  const navigate = useNavigate();
  const [labelsArr, setLabelsArr] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const thread = useSelector(getThread);
  const [loading, setLoading] = useState(true);

  const product = useSelector(getProduct);
  const feedFilter = useSelector(getFeedFilter);
  const [loadingMentions, setLoadingMentions] = useState(true);
  const [loadingGraph, setLoadingGraph] = useState(true);
  const [competitors, setCompetitors] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [totalMentions, setTotalMentions] = useState(0);
  const [client, setClient] = useState("");
  const [previousMentions, setPreviousMentions] = useState(0);
  const referencesFilter = useSelector(getReferences);
  const [dateString, setDateString] = useState([
    feedFilter.from,
    feedFilter.to,
  ]);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
  };

  return (
    <div>
      <div className="white-block">
        <div className="grey">
          <h1 className="">Мониторинг конкурентного поля</h1>
          <span>
            <CheckCircleFilled className="green" /> Распределение информационных
            поводов (Share-of-Voice)
          </span>
        </div>
        <div className="grid2-1">
          <div className="margin-top">
            <div className="grid2 margin-bottom">
              <div className="flex">
                <div className="user-widget">
                  <img src={"/esen.png"} alt="" />
                </div>
                <div className="share-widget">
                  <h3>ООО Ессентуки минеральные воды</h3>
                  <div className="flex-baseline">
                    <h2>3.5 </h2>
                    <h2 className="red">
                      -20.81%
                      <ArrowDownOutlined />
                    </h2>
                  </div>
                </div>
              </div>
              <div className="flex">
                <div className="user-widget">
                  <img src={"/snti.png"} alt="" />
                </div>
                <div className="share-widget">
                  <h3>ООО Святой источник</h3>
                  <div className="flex-baseline">
                    <h2>3 </h2>
                    <h2 className="tiffany">
                      {" "}
                      70.81%
                      <ArrowUpOutlined />
                    </h2>
                  </div>
                </div>
              </div>
              <div className="flex">
                <div className="user-widget">
                  <img src={"/archiz.png"} alt="" />
                </div>
                <div className="share-widget">
                  <h3>ООО Архыз</h3>
                  <div className="flex-baseline">
                    <h2>6 </h2>
                    <h2 className="red">
                      {" "}
                      -15.05%
                      <ArrowDownOutlined />
                    </h2>
                  </div>
                </div>
              </div>
              <div className="flex">
                <div className="user-widget">
                  <img src={"/cola.png"} alt="" />
                </div>
                <div className="share-widget">
                  <h3>The Coca-Cola Company</h3>
                  <div className="flex-baseline">
                    <h2>147 </h2>
                    <h2 className="tiffany">
                      {" "}
                      23.81%
                      <ArrowDownOutlined />
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {loading ? (
            <div className="feed-posts-loader" style={{ height: "300px" }}>
              <LoadingOutlined />
            </div>
          ) : (
            <>
              <PieChart />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default ShareofVoices;
